export const GET_TOKEN_VALIDATE = 'GET_TOKEN_VALIDATE'
export const GET_REFRESH_TOKEN = 'GET_REFRESH_TOKEN'
export const RESET_XSRF_TOKEN = 'RESET_XSRF_TOKEN'
